module.exports = __webpack_public_path__ + "static/img/very_good.a140d1f9.png";